app.constant('config', {
    APPLICATION_CUSTOMER:   'Saneo S.A.',
    APPLICATION_NAME:       'ALAB MeedyDoctors',
    VERSION:                '1.0.0',
    API_URL:                'https://alab.meedydoctors.pl/api/edm/api/v1',
    AUTH_URL:               'https://alab.meedydoctors.pl/api/edm/auth/authenticate',
    LOGOUT_URL:             'https://alab.meedydoctors.pl/api/edm/api/v1/auth/invalidate',
    SAIKU_URL:              './saiku/saiku/rest',
    SAIKU_APP:              'https://alab.meedydoctors.pl/api/edm/',
    DEV_MODE:               false,
    MEEDY:                  true
});